import axios, { AxiosRequestHeaders } from 'axios';
import { getToken } from 'utils/auth';
import { putStorageItem } from 'utils/helpers';

export const createAxiosInstance = (customHeaders?: AxiosRequestHeaders) => {
  const token = getToken();

  const authorizationParams = {
    Authorization: token ? `Bearer ${token}` : false,
  };

  const headers = {
    'Content-Type': 'application/json',
    ...authorizationParams,
    Accept: 'application/json',
    ...customHeaders,
  };

  const instance = axios.create({
    baseURL: '/api/v1/',
    headers,
  });

  instance.interceptors.response.use(
    ({ data }) => data,
    async (error) => {
      const originalRequest = error.config;

      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        let response;

        try {
          response = await axios.get('/api/v1/auth/refresh-token');
        } catch (err) {
          response = null;
        }

        const newToken = response?.data?.token;

        if (newToken) {
          putStorageItem('token', newToken);
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
        }

        return instance(originalRequest);
      }

      return Promise.reject(error.response);
    }
  );

  return instance;
};

export const axiosInstanceWithToken = createAxiosInstance;
